import React from "react";
import { useTheme } from "@mui/material/styles";
import GroupIcon from "@mui/icons-material/Group";
import { IconButton, TableCell, TableRow, Tooltip } from "@mui/material";

import { AssignTargetStyle } from "./AssignTarget.Style";
import { appUrl, capitalizeFirstLetter, TYPE } from "../../../../utils/Utils";
import { ContentCopy, Edit } from "@mui/icons-material";
import UserDialog from "../dialog/dialogBody/User.dialog";
import { InputValidation } from "../../../../utils/InputValidationRegex";
import HocPopup from "../../../../hoc/hocPopup";
import { useAuth } from "../../../../context/Auth.context";
import { useAppContext } from "../../../../context/App.context";

const AssignTargetCardComponent = ({ row, dialog }) => {
  const theme = useTheme();
  const auth = useAuth();
  const app = useAppContext();
  const getWorkFlowDetails = auth?.user?.associateDetails?.filter((data) => {
    return data?.dealership_id === auth?.user?.dealership_id;
  });
  console.log("getWorkFlowDetails", getWorkFlowDetails);

  // let url = `${appUrl}/getUserDetails/${app?.user?.user_id}/${auth.user.dealership_id}/${getWorkFlowDetails[0]?.verification_workflow_id}`;
  console.log("userID:  ", row?.user?.user_id);
 
  return (
    <>
      <TableRow>
        <TableCell sx={{ border: "none", alignItems: "center", width: "4%" }}>
          {row?.role === "manager" ? (
            <GroupIcon
              sx={{
                color: theme.palette.primary.main,
                marginX: "12px",
                width: "20px",
              }}
            />
          ) : (
            <GroupIcon
              sx={{
                visibility: "hidden",
                marginX: "12px",
                width: "20px",
              }}
            />
          )}
        </TableCell>
        <TableCell
          sx={{
            border: "none",
            alignItems: "center",
            textAlign: "left",
            width: "18%",
          }}
        >
          <span>
            {capitalizeFirstLetter(row.first_name) +
              " " +
              capitalizeFirstLetter(row.last_name)}
          </span>
        </TableCell>
        <TableCell
          align="center"
          sx={{ ...AssignTargetStyle.noBorder, paddingY: "8px", width: "18%" }}
        >
          {row.email}
        </TableCell>

        <TableCell
          align="center"
          sx={{ ...AssignTargetStyle.noBorder, paddingY: "8px", width: "18%" }}
        >
          {InputValidation.phoneNumberFormat(row.mobile_number)}
        </TableCell>
        <TableCell
          align="center"
          sx={{ ...AssignTargetStyle.noBorder, paddingY: "8px", width: "18%" }}
        >
          {row.previous_target}
        </TableCell>
        <TableCell
          align="center"
          sx={{ ...AssignTargetStyle.noBorder, paddingY: "8px", width: "8%" }}
        >
          {row.completed}
        </TableCell>
        <TableCell
          align="center"
          sx={{ ...AssignTargetStyle.noBorder, paddingY: "8px", width: "18%" }}
        >
          {row.assigned_target}
          
        </TableCell>
        {getWorkFlowDetails[0]?.crm_user_status ? (
          <TableCell
            align="center"
            sx={{
              ...AssignTargetStyle.noBorder,
              paddingY: "8px",
              width: "18%",
            }}
          >
            <Tooltip title="Copy" placement="top">
              <IconButton
                onClick={() => {
                  console.log(
                    "USER: " + JSON.stringify(auth.user.dealership_id)
                  );
                  navigator.clipboard.writeText(
                    `${appUrl}/getUserDetails/${JSON.stringify(
                      row?.employee_user_id
                    )}/${JSON.stringify(
                      auth?.user?.dealership_id
                    )}/${JSON.stringify(row?.verification_workflow_id)}`
                  );
                }}
              >
                <ContentCopy color="primary" />
              </IconButton>
            </Tooltip>
          </TableCell>
        ) : null}

        <TableCell
          align="center"
          sx={{ ...AssignTargetStyle.noBorder, paddingY: "8px", width: "8%" }}
        >
          <Edit
            style={{ color: "darkcyan" }}
            variant="text"
            sx={{
              height: "40px",
              alignSelf: "flex-end",
              marginRight: "16px",
              cursor: "pointer",
            }}
            onClick={() => {
              dialog({
                open: true,
                bodyType: TYPE.UPDATE_USER,
                body: <UserDialog row={row} edit={true} />,
              });
            }}
          />
        </TableCell>
      </TableRow>
    </>
  );
};

export default HocPopup(AssignTargetCardComponent);
